import { render, staticRenderFns } from "./EditOrderMaterialToggle.vue?vue&type=template&id=61090e2a&scoped=true"
import script from "./EditOrderMaterialToggle.vue?vue&type=script&lang=js"
export * from "./EditOrderMaterialToggle.vue?vue&type=script&lang=js"
import style0 from "./EditOrderMaterialToggle.vue?vue&type=style&index=0&id=61090e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61090e2a",
  null
  
)

export default component.exports